import { render } from "./DivisionDetails.vue?vue&type=template&id=184470f6"
import script from "./DivisionDetails.vue?vue&type=script&lang=js"
export * from "./DivisionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__